import { useEffect } from 'react';
import { useLocation } from 'react-router';

/**
 * Remplace le comportement d'ancre natif que le routeur court-circuite :
 * saut vers l'ancre si l'URL en porte une, retour en haut de page sinon.
 */
export function useScrollToHash(): void {
  const { pathname, hash, key } = useLocation();

  useEffect(() => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const behavior: ScrollBehavior = reduced ? 'auto' : 'smooth';

    if (!hash) {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      return;
    }

    // L'ancre peut ne pas être montée au moment où l'URL change.
    const frame = requestAnimationFrame(() => {
      const target = document.getElementById(decodeURIComponent(hash.slice(1)));
      target?.scrollIntoView({ behavior, block: 'start' });
    });

    return () => cancelAnimationFrame(frame);
  }, [pathname, hash, key]);
}
